<template>
  <div>
    <slot name="header"></slot>
    <div class="main-title-modal logos">
      <img class="main-title-modal logo ores-logo" :src="require('@/assets/Ores.svg')" alt="Logo ORES" />
      <img class="main-title-modal logo resa-logo" :src="require('@/assets/Resa.svg')" alt="Logo RESA" />
      <img class="main-title-modal logo swde-logo" :src="require('@/assets/SWDE.svg')" alt="Logo SWDE" />
      <img class="main-title-modal logo proximus-logo" :src="require('@/assets/Proximus.svg')" alt="Logo Proximus" />
      <img class="main-title-modal logo voo-logo" :src="require('@/assets/Orange.svg')" alt="Logo Orange" />
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'cmh-modal-partners'
})
export default class CmhModalPartners extends Vue {
}
</script>

<style scoped>
.logos {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  place-content: center;
  gap: 0.8rem
}

.logos>* {
  position: static;
  max-height: 100px;
  min-height: 50px;
}

@media screen and (min-width: 577px) {
  .main-title-modal.text {
    font-size: 17px;
    margin: 20px auto;
    width: 500px;
  }

  .main-title-modal.logos {
    width: 400px;
    height: 100px;
    margin: 0 auto 10px;
  }
}

@media screen and (max-width: 576px) {
  .main-title-modal.text {
    font-size: 15px;
    margin: 20px auto;
  }

  .main-title-modal.logos {
    width: 260px;
    height: 70px;
  }
}
</style>
